import React, { useContext, useState } from "react";
import styled from "styled-components";
import { UserContext } from "../contexts/UserContext";

const TabsStyle = styled.div`
    display: flex;
    overflow: hidden;
    background-color: transparent;
    border-bottom: 1px solid ${props => props.theme.greyLight};

`;

const TabButtonStyle = styled.button`
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    transition: 0.3s;
    min-width: 100px;
    padding: 6px 15px;
    margin-bottom: 0px; /* HACK: safari workaround */
    border-radius: 2px 2px 0 0;
    color: ${props => props.theme.black};
    background-color: ${props => props.theme.greyLighter};
    &:not(:last-child) {
        margin-right: 10px;
    }
    &:hover {
        background-color: ${props => props.theme.greyLight};
    }
    &.active {
        color: ${props => props.theme.white};
        background-color: ${props => props.theme.primaryLight};
        &:hover {
            background-color: ${props => props.theme.primaryLighter};
        }
    }
    &.disabled {
        color: ${props => props.theme.greyLight};
        background-color: ${props => props.theme.greyLighter};
        &:hover {
            background-color: ${props => props.theme.greyLighter};
        }
    }
`;

const TabContentStyle = styled.div`
    display: none;
    border-top: none;
    background-color: transparent;
    height: ${props => props.$height};
    &.active {
        display: block;
    }
`;

export const Tab = props => <>{props.children}</>;

export const Tabs = props => {

    const { children, contentHeight } = props;

    const userContext = useContext(UserContext);

    const [activeTab, setActiveTab] = useState(props.activeTab ? parseInt(props.activeTab, 10) : 0);
    const tabs = (Array.isArray(children) ? children : [children])
        .filter(child => child.props)
        .filter(child => userContext.checkFeature(child.props.featureFor));
    const height = contentHeight ? contentHeight : "auto";

    const onChangeTab = (child, index) => {
        if (!isDisabled(child)) {
            if (props.onChangeTab !== undefined) {
                props.onChangeTab(index);
            }
            setActiveTab(index);
        }
    };

    const isDisabled = child => {
        const { disabled } = child.props;
        return disabled === "true" || disabled === true;
    };

    const isActive = index => index === activeTab;

    return (
        <div>
            <TabsStyle>
                {tabs.map((child, index) =>
                    <TabButtonStyle
                        key={index}
                        onClick={() => onChangeTab(child, index)}
                        className={(isActive(index) ? "active" : "") + " " + (isDisabled(child) ? "disabled" : "")}>
                        {child.props.title}
                    </TabButtonStyle>
                )}
            </TabsStyle>
            {tabs.map((child, index) =>
                !isDisabled(child) &&
                <TabContentStyle
                    key={index}
                    $height={height}
                    className={index === activeTab ? "active" : ""}>
                    {child.props.children}
                </TabContentStyle>
            )}
        </div>
    );
};